import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'htmlDecode'})
export class HtmlDecodePipe implements PipeTransform {
    constructor() {
        
    }

    transform(value: string): string {

        if (value == null || value === '') {
            return '';
        }

        // Use the DOM to decode entities. `textarea` is used instead of a div
        // because setting innerHTML on it does not execute scripts/images and
        // its value is read back as plain decoded text.
        const textarea = document.createElement('textarea');
        textarea.innerHTML = value;
        return textarea.value;
    }
}
